import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X, ArrowUpRight, Phone } from "lucide-react";

const LINKS = [
    { label: "Home", to: "/", testid: "nav-link-home" },
    { label: "About Us", to: "/about", testid: "nav-link-about" },
    { label: "Contact Us", to: "/contact", testid: "nav-link-contact" },
];

export const Nav = () => {
    const [open, setOpen] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => setOpen(false), [pathname]);

    return (
        <header className="fixed top-0 inset-x-0 z-50 px-3 sm:px-6 pt-4">
            <nav className="glass mx-auto flex max-w-6xl items-center justify-between rounded-2xl px-4 sm:px-6 py-3">
                <Link
                    to="/"
                    data-testid="nav-brand-logo"
                    className="flex items-baseline gap-2"
                >
                    <span className="f-display text-lg sm:text-xl font-black tracking-tight text-white">
                        VIVEK<span className="text-[#FF5500]">.</span>
                    </span>
                    <span className="hidden sm:inline f-mono text-[9px] uppercase tracking-[0.28em] text-slate-400">
                        Coaching Centre
                    </span>
                </Link>

                <div className="hidden md:flex items-center gap-9">
                    {LINKS.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={l.testid}
                            className={({ isActive }) =>
                                "nav-link" + (isActive ? " active" : "")
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </div>

                <div className="flex items-center gap-3">
                    <a
                        href="tel:+916207984279"
                        data-testid="nav-phone-link"
                        className="hidden lg:flex items-center gap-2 f-mono text-xs text-slate-300 hover:text-white transition-colors"
                    >
                        <Phone size={14} className="text-[#FF5500]" />
                        6207984279
                    </a>
                    <Link
                        to="/contact"
                        data-testid="nav-cta-admissions"
                        className="btn-primary hidden sm:inline-flex !py-2.5 !px-5 !text-sm"
                    >
                        Admissions Open
                        <ArrowUpRight size={16} />
                    </Link>
                    <button
                        className="md:hidden rounded-xl border border-white/10 p-2 text-white"
                        data-testid="nav-mobile-toggle"
                        aria-label="Toggle menu"
                        onClick={() => setOpen((v) => !v)}
                    >
                        {open ? <X size={20} /> : <Menu size={20} />}
                    </button>
                </div>
            </nav>

            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0, y: -12 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -12 }}
                        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                        className="glass mx-auto mt-2 max-w-6xl rounded-2xl p-4 md:hidden"
                        data-testid="nav-mobile-menu"
                    >
                        <div className="flex flex-col">
                            {LINKS.map((l) => (
                                <NavLink
                                    key={l.to}
                                    to={l.to}
                                    data-testid={`${l.testid}-mobile`}
                                    className={({ isActive }) =>
                                        "rounded-xl px-4 py-3 f-display font-bold text-slate-200 " +
                                        (isActive
                                            ? "bg-white/5 text-[#FF5500]"
                                            : "")
                                    }
                                >
                                    {l.label}
                                </NavLink>
                            ))}
                            <a
                                href="tel:+916207984279"
                                className="mt-2 flex items-center gap-2 rounded-xl px-4 py-3 f-mono text-sm text-slate-300"
                            >
                                <Phone size={15} className="text-[#FF5500]" />
                                Call 6207984279
                            </a>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </header>
    );
};

export default Nav;
